/**
 * @warning 公共文件！！！！严禁加业务代码
 */

import { State, Store } from '@medlinker/fundamental';
import env from '../../shared/utils/env';
import request from '../../shared/request';
import { hosts } from '../../shared/constants';

export interface UserState {
  info: null | any;
  focusedOfficials: { [key: string]: boolean };
}

let userInfoRequestPromise: any = null;

const model = {
  name: 'user',
  state: {
    info: null,
    focusedOfficials: {},
  } as UserState,
  persist: true,
  baseReducer(state: State, action: any) {
    return state;
  },

  reducers: {
    setUserInfo(state: UserState, payload: UserState['info']) {
      state.info = payload;
    },
    setOfficialFocus(state: UserState, payload: [string, boolean]) {
      state.focusedOfficials[payload[0]] = payload[1];
    },
  },
  effects: {
    /**
     * 获取用户信息
     */
    async loadUserInfo(payload: {}, { dispatch }: Store) {
      if (!userInfoRequestPromise) {
        userInfoRequestPromise = await request.get<any, any>(
          `/v1/user/profile`
        );
      }
      try {
        const res = await userInfoRequestPromise;

        dispatch.user.setUserInfo(res);

        return res;
      } catch (e) {
        throw e;
      } finally {
        userInfoRequestPromise = null;
      }
    },

    async ensureUserInfo(payload: {}, { getState, dispatch }: Store) {
      if (getState().user.info) {
        return getState().user.info;
      }

      const [err, result] = await dispatch.user.loadUserInfo({});

      if (err) {
        throw err;
      }

      return result;
    },

    /**
     * 获取公众号关注信息
     */
    async loadOfficialIsFocused(
      payload: { _opentype: string },
      { dispatch }: Store
    ) {
      const data = await request
        .get<any, any>(`/user/is-subscribe`, {
          baseURL: hosts.WECHAT,
        })
        .setParams({
          wxPlatform: payload._opentype,
          isWxEnv: Number(env.isWechat),
        });

      dispatch.user.setOfficialFocus([payload._opentype, !!data.isSubscribe]);
    },

    /**
     * 更新用户信息
     */
    async updateUserProfile(payload: any, { dispatch }: Store) {
      const data = await request
        .post<any, any>(`/v1/user/profile`, {
          bodyType: 'json',
        })
        .setData(payload);

      await dispatch.user.loadUserInfo({});

      return data.message;
    },
  },
};

export default model;
